import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IGenericFormLoader } from '../../interfaces/form-label';
import { FormGroup, FormBuilder } from '@angular/forms';

export interface FormData{
  variables:{}
}
@Component({
  selector: 'cargoes-approval',
  templateUrl: './aeo-approval.component.html',

})
export class AEOApprovalComponent implements OnInit, IGenericFormLoader {
  @Input() public defaultFormData!: string;
  @Output() public submitedFormData = new EventEmitter<FormData>();
  public actions: string[] = [];
  public actionCommentsGroup!: FormGroup;
  // eslint-disable-next-line no-empty-function
  constructor(private formBuilder: FormBuilder) { }

  ngOnInit():void {
    this.onLoad(this.defaultFormData);


  }

  /**
   * A - Approval, R - Reject, M - MoreInfo
   * @param defaults | ARMC
   */
  onLoad(data: string):void {
    this.actions = this.prepareActions(data);
    this.actionCommentsGroup = this.formBuilder.group({
      selectedAction: [''],
      comments: [''],
    });
  }

  prepareActions(data: string): string[] {
    const actions:string[] = [];
    if (data && data.length > 0) {
      data.split(',').forEach((d) => {
        if (d.toLowerCase() === 'pfi')
          actions.push('Pending for Information');
        if (d.toLowerCase() === 'pfa')
          actions.push('Pending Final approval');
        if (d.toLowerCase() === 'a')
          actions.push('Approved');
        if (d.toLowerCase() === 'r')
          actions.push('Rejected');
      });
    }

    return actions;
  }

  onSubmit() : void{
    const formData = {
      'variables': {
        'action': { 'value': this.actionCommentsGroup.value.selectedAction },
        'comments': { 'value': this.actionCommentsGroup.value.comments }
      }
    };
    this.submitedFormData.emit(formData);
  }
}
